import { getReactionBadgeSummary } from "../../utils/messageReactions";

export function ReactionBadge({ reacts, className = "" }) {
  const summary = getReactionBadgeSummary(reacts);

  if (summary.total === 0) return null;

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full bg-white px-1.5 py-0.5 text-[11px] leading-none shadow-md ring-1 ring-black/5 ${className}`.trim()}
      aria-label={`${summary.total} cảm xúc`}
      title={`${summary.total} cảm xúc`}
    >
      <div className="flex items-center -space-x-1">
        {summary.items.map((reaction) => (
          <span
            key={reaction.name}
            className="flex h-4 w-4 items-center justify-center rounded-full bg-white text-[11px]"
            aria-hidden="true"
          >
            {reaction.icon}
          </span>
        ))}
      </div>
      <span className="font-medium text-gray-700">{summary.total}</span>
    </div>
  );
}

export default ReactionBadge;
